import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutPage } from './layout/layout.page';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
  {
    path: 'home',
    component: LayoutPage,
    children: [
      {
        path: '',
        redirectTo: 'new-orders',
        pathMatch: 'full',
      },
      {
        path: 'new-orders',
        loadChildren: () => import('../app/new-orders/new-orders.module').then(m => m.NewOrdersPageModule)
      },
      {
        path: 'order-preparation',
        loadChildren: () => import('../app/order-preparation/order-preparation.module').then(m => m.OrderPreparationPageModule)
      },
      {
        path: 'order-checking',
        loadChildren: () => import('./order-checking/order-checking.module').then( m => m.OrderCheckingPageModule)
      },
      {
        path: 'account',
        loadChildren: () => import('../app/account/account.module').then(m => m.AccountPageModule)
      },
      {
        path: 'orders-file',
        loadChildren: () => import('../app/orders-file/orders-file.module').then(m => m.OrdersFilePageModule)
      }
    ],
    canActivate: [LoginGuard]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then( m => m.TermsAndConditionsPageModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'menu',
    loadChildren: () => import('../app/menu/menu.module').then( m => m.MenuPageModule)
  },
  {
    path: 'order-detail/:id',
    loadChildren: () => import('./order-detail/order-detail.module').then( m => m.OrderDetailPageModule)
  },
  {
    path: 'orders-file',
    loadChildren: () => import('./orders-file/orders-file.module').then( m => m.OrdersFilePageModule)
  },
  {
    path: 'extras',
    loadChildren: () => import('./extras/extras.module').then( m => m.ExtrasPageModule)
  }



  /*{
    path: 'account',
    loadChildren: () => import('./account/account.module').then( m => m.AccountPageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule)
  }*/

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
